import type { Consultation } from '@/hooks/patients/usePatientConsultations';
import { useAppStore } from '@/state-management/store';
import { PaymentRequestType } from '@montugroup/pms-api-contracts/build/api-pms/consultation/contracts/request-payment.contract';
import { useEffect } from 'react';

interface UseConsultationStateInitializerProps {
  consultations: Consultation[];
  isSuccess: boolean;
}

export const useConsultationStateInitializer = ({ consultations, isSuccess }: UseConsultationStateInitializerProps) => {
  const setConsultationField = useAppStore((state) => state.setConsultationField);

  useEffect(() => {
    if (!isSuccess || consultations.length === 0) {
      return;
    }

    consultations.forEach((consultation) => {
      if (!consultation?.id) {
        return;
      }

      if (consultation.isMarkedAsComplimentary !== undefined && consultation.isMarkedAsComplimentary !== null) {
        setConsultationField(consultation.id, 'isMarkedAsComplimentary', consultation.isMarkedAsComplimentary);
      }

      const paymentRequestType = consultation.isMarkedAsComplimentary
        ? PaymentRequestType.COMPLIMENTARY
        : consultation.pricingTier?.name ?? null;

      setConsultationField(consultation.id, 'paymentRequestType', paymentRequestType);
    });
  }, [isSuccess, consultations, setConsultationField]);
};
